@if (cart$ | async; as cart) {
  @if (entries$ | async; as entries) {
    @if (cart.totalItems > 0) {
      <div class="cart-details-wrapper">
        <div class="cx-total row cart-name">
          {{ 'cartDetails.cartName' | cxTranslate: {code: cart.code} }}
        </div>
        <div class="cx-total row">
          <div class="col-12 col-lg-8 pl-0 mb-4">
            <app-cart-actions></app-cart-actions>
          </div>
          @if (canPlaceOrders$ | async) {
            <div class="col-12 col-md-4 mb-4">
              @if (cart.skipAutomaticCalculation && !cart.calculatedForCheckout && !cart.fromConfigurator) {
                @if (entries.length) {
                  <button
                    class="btn btn-primary btn-block"
                    type="button" (click)="calculateCart()">
                    {{ 'cartAdministration.cart.calculate' | cxTranslate }}
                  </button>
                }
              } @else {
                @if (entries.length) {
                  <button [routerLink]="{ cxRoute: 'checkout' } | cxUrl"
                    class="btn btn-primary btn-block"
                    type="button" (click)="publishFieldMarks()">
                    {{ 'cartDetails.proceedToCheckout' | cxTranslate }}
                  </button>
                }
              }
            </div>
          }
        </div>
        @if (orderPromotions$ | async; as orderPromotions) {
          <cx-promotions [promotions]="orderPromotions"></cx-promotions>
        }
        <app-efa-cart-item-list [items]="entries"
          [cartIsLoading]="isLoading$ | async"
          [promotionLocation]="promotionLocation"
          [fromConfigurator]="cart.fromConfigurator"
                              [options]="{
                                isSaveForLater: false,
                                optionalBtn: saveForLaterBtn
                              }"></app-efa-cart-item-list>
      </div>
    }
  }
}

<ng-template let-ctx #saveForLaterBtn>
  @if (selectiveCartEnabled) {
    <div
      class="col-md-3 col-lg-3 col-xl-3 cx-sfl-btn">
      <button class="link cx-action-link"
        [disabled]="ctx.loading"
        (click)="saveForLater(ctx.item)"
        type="button">
        {{ 'saveForLaterItems.saveForLater' | cxTranslate }}
      </button>
    </div>
  }
</ng-template>
